import React from 'react';
import { Button } from 'antd';
import { isFunction } from 'lodash';
import './index.less';
import IconTip from '@/components/icon-tip';

const CardWarp = (props) => {
  const { title = '', extra = '', children, operator = {}, className, isMountParent } = props;
  const { operatorName, action } = operator ?? {};
  const renderExtra = (str) => {
    if (!str) {
      return '';
    }
    if (isMountParent) {
      return <IconTip title={str} getPopupContainer={(triggerNode) => triggerNode.parentNode} />;
    }
    return <IconTip title={str} />;
  };
  const calcClass = () => {
    return `${className || ''} component-card-warp`;
  };
  return (
    <section className={calcClass()}>
      <div className="title-info">
        <h3>
          {title} {extra ? renderExtra(extra) : ''}
        </h3>
        {operatorName ? (
          <span>
            <Button
              type="primary"
              onClick={() => {
                isFunction(action) && action();
              }}
            >
              {operatorName}
            </Button>
          </span>
        ) : (
          ''
        )}
      </div>
      {children}
    </section>
  );
};

export default CardWarp;
